export const avoidPageBreak = 'o-print-avoid-break';
export const body = 'o-print-body';
export const hide = 'o-print-hide';
export const print = 'o-print-print';
